<div class="modal-header">
  <h4 class="modal-title">Inclusão de Taxa de Atualização de Garantia - CL</h4>
  <button _ngcontent-jop-c162="" type="button" aria-label="Close" class="btn-close float-end" (click)="fechar()">
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="formulario">
    <div class="mt-3 row">
      <div class="bn-form-group col-md-4">
        <label class="form-label" for="dataInicioValidade"><b>Data Início Validade</b></label>
        <bn-datepicker name="dataInicioValidade" idInput="dataInicioValidade" formControlName="dataInicioValidade" ngDefaultControl
          required="required" [minDate]="hoje">
        </bn-datepicker>
      </div>
      <div class="bn-form-group col-md-4">
        <label class="form-label" for="ideIndexador"><b>Taxa de Atualização de Garantia</b></label>
        <select id="ideIndexador" class="form-select" name="ideIndexador" formControlName="ideIndexador">
          <option [value]="opcao.id" *ngFor="let opcao of indexadores">
            {{opcao.nome}}
          </option>
        </select>
      </div>
      <div class="bn-form-group col-md-4">
        <label class="form-label" for="taxaGarantia"><b>Taxa </b></label>
        <input class="form-control" name="taxaGarantia" ngDefaultControl formControlName="taxaGarantia">
      </div>
    </div>
    <div class="mt-3 row">
      <div class="bn-form-group col-md-4">
        <label class="form-label" for="dataFinalValidade"><b>Data Final Validade</b></label>
        <bn-datepicker name="dataFinalValidade" idInput="dataFinalValidade" formControlName="dataFinalValidade" ngDefaultControl
        [minDate]="hoje"></bn-datepicker>
      </div>
      <div class="bn-form-group col-md-4">
        <label class="form-label" for="ideModalidade"><b>Modalidade</b></label>
        <select id="ideModalidade" class="form-select" name="ideModalidade" formControlName="ideModalidade">
          <option [value]="opcao.id" *ngFor="let opcao of modalidadesOpe">
            {{opcao.nome}}
          </option>
        </select>
      </div>
    </div>
  </form>

  <div *ngIf="mensagemAviso" class="alert alert-warning">
    {{mensagemAviso}}
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary" (click)="fechar()">Cancelar</button>
  <button class="btn btn-primary" [disabled]="formulario.invalid" (click)="salvar()">Salvar</button>
</div>